// extracted by mini-css-extract-plugin
export var actions = "_3v-0";
export var actionsContainer = "_3v-6";
export var border = "_3v-1";
export var childFullHeight = "_3v-d";
export var collapse = "_3v-2";
export var content = "_3v-8";
export var contentChild = "_3v-c";
export var fullscreen = "_3v-a";
export var headerContainer = "_3v-3";
export var headerRow = "_3v-5";
export var hidePadding = "_3v-9";
export var noScrollX = "_3v-e";
export var noScrollY = "_3v-f";
export var optOutTopPadding = "_3v-b";
export var pagePadding = "_3v-7";
export var profile = "_3v-g";
export var profileContainer = "_3v-h";
export var profileImage = "_3v-i";
export var profileMain = "_3v-j";
export var profileSubtitle = "_3v-l";
export var profileTitle = "_3v-k";
export var tabsWrapper = "_3v-4";
export var title = "_3v-m";